import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const BroadcastHistory = () => {
  const qc = useQueryClient();
  const { data: list = [] } = useQuery({ queryKey: ["admin-broadcasts"], queryFn: () => api.get("/admin/broadcasts").then((r) => r.data), refetchInterval: 10000 });
  const retry = async (b) => {
    if (!window.confirm(`Re-send "${b.subject}" to the ${b.failed} member${b.failed === 1 ? "" : "s"} it failed for?`)) return;
    try {
      const { data } = await api.post(`/admin/broadcasts/${b.id}/retry`);
      toast.success(`Retrying ${data.queued} failed send${data.queued === 1 ? "" : "s"}`);
      setTimeout(() => qc.invalidateQueries({ queryKey: ["admin-broadcasts"] }), 2000);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!list.length) return null;
  return (
    <div className="rounded-2xl bg-[#1B2A41] border border-[#2C3E55] overflow-hidden" data-testid="admin-broadcast-history">
      <p className="p-4 text-sm text-[#F8FAFC]/70 border-b border-[#2C3E55]">Emails you've sent to F.E.R.Ms. Progress updates while a send is running.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-wider text-[#8FA58A] bg-[#121E2B]">
            <tr>{["When", "Subject", "Audience", "Progress", "Status", ""].map((h) => <th key={h} className="px-4 py-3 font-type">{h}</th>)}</tr>
          </thead>
          <tbody>
            {list.map((b) => (
              <tr key={b.id} data-testid={`admin-broadcast-row-${b.id}`} className="border-t border-[#2C3E55]/60">
                <td className="px-4 py-2 whitespace-nowrap text-[#F8FAFC]/60">{new Date(b.created_at).toLocaleString("en-AU", { dateStyle: "short", timeStyle: "short" })}</td>
                <td className="px-4 py-2 max-w-xs truncate" title={b.subject}>{b.subject}</td>
                <td className="px-4 py-2 text-[#F8FAFC]/75 max-w-xs truncate" title={b.audience}>{b.audience}</td>
                <td className="px-4 py-2 whitespace-nowrap">{b.sent} / {b.total}{b.failed ? <span className="text-[#E2705A]"> · {b.failed} failed</span> : null}</td>
                <td className="px-4 py-2"><span className={`text-[11px] px-2 py-0.5 rounded-full ${b.status === "done" ? "bg-[#8FA58A]/20 text-[#8FA58A]" : "bg-[#E2705A]/20 text-[#E2705A]"}`}>{b.status}</span></td>
                <td className="px-4 py-2 text-right whitespace-nowrap">
                  {b.failed > 0 && b.status === "done" && (
                    <button type="button" onClick={() => retry(b)} data-testid={`admin-broadcast-retry-${b.id}`} className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-[#E2705A] hover:bg-[#D35D46] text-[#FDFBF7] text-xs font-semibold transition-colors">
                      <RotateCcw className="w-3.5 h-3.5" /> Retry {b.failed} failed
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
